import WithRender from "../../templates/tables/optionsTable.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getIsCimpressProduct", "getShowOptionsTable"]),
    name: () => {
      return "Options";
    }
  }
});
